<template>
    <div ref="container">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'MasonryComponent',

        created() {
            this.$nextTick( () => {
                let count = this.$refs.container.querySelectorAll('img').length;
                if ( count ) {
                    let loaded = 0;
                    let interval = setInterval( () => {
                        this.$refs.container.querySelectorAll('img').forEach( img => {
                            if ( img.complete ) {
                                loaded++;
                            }
                        } );

                        if ( loaded === count ) {
                            clearInterval( interval );

                            setTimeout( () => {
                                this.$redrawVueMasonry('masonry')
                            }, 500 )
                        }
                    }, 500 );
                }
            } )
        }
    }
</script>



// WEBPACK FOOTER //
// Masonry.vue?205c6b9f